// extracted by mini-css-extract-plugin
export default {"Text":"ChecksStatusBadgeHeader-module__Text--mNbul","Text_1":"ChecksStatusBadgeHeader-module__Text_1--Ccfb0","Text_2":"ChecksStatusBadgeHeader-module__Text_2--d8Yn7"};